import CategoryIcon from '@mui/icons-material/Category';
import styles from "./FilterByProduct.module.scss";
import ButtonBase from '@mui/material/ButtonBase';
import { useState } from 'react';
import DefineProductPopup from '../../../../../CustomElements/statePopups/defineProductPopup/DefineProductPopup';

interface IProps{
    onSelectedProduct:any;
    ignoreProductParameterizedVariables?:boolean
}
export default function FilterByProductButton(props:IProps) {

    const [open, setOpen] = useState(false);

    return (
        <>
        {open && (
            <DefineProductPopup
           
            ignoreProductParameterizedVariables={props?.ignoreProductParameterizedVariables}
            onClose={() => {
                setOpen(false);
            }} onConfirm={(resultingProductSelected:any) => {
                props.onSelectedProduct(resultingProductSelected);
                setOpen(false);
            }}/>
        )}
        <ButtonBase onClick={() => {
            setOpen(true);
        }}>
        <div className={styles.filterByProductBtnContainer}>
            <div>
                <div style={{display:"flex",justifyContent:"center"}}>
                    <CategoryIcon fontSize="large"/>
                </div>
                <div style={{fontSize:13}}>Produto</div>
            </div>
        </div></ButtonBase>
        </>
    );
}